import React from "react";
import {useStore} from 'react-redux';

function InteressesConfirmacaoModal(props){

	const i18n = useStore().getState().i18n

	return (
		<>
		<div className={props.visivel === true ? 'modal is-active' : 'modal'}>
            <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head">
                    <p className="modal-card-title">{props.titulo}</p>
                    </header>
                    <section className="modal-card-body">
                    {props.conteudo}
                    </section>
                <footer className="modal-card-foot interesse-obrigatiorio-container" style={{textAlign:'center'}}>
					<button onClick={props.voltarInteresse} className="weex-button" aria-label="close">
                            {i18n.message("geral.cancelar", "Cancelar")}
                    </button>
					<button onClick={props.submitInteresse} className="weex-button">
                            {i18n.message("geral.confirmar", "Confirmar!")}
                    </button>     
                </footer>
            </div>
        </div>
		</>
	);
}

export default InteressesConfirmacaoModal;